import React, { useEffect, useState } from 'react'
import ProductDetailStartSection from '../components/product/ProductDetailStartSection'
import AboutProduct from '../components/product/AboutProduct'
import ProductReview from '../components/product/ProductReview'
import SimilarProducts from '../components/product/SimilarProducts'
import NeedOfCustomDesign from '../components/home/NeedOfCustomDesign'
import FollowOnInstagram from '../components/home/FollowOnInstagram'
import { getItemsByID } from '../services/OurCategories'
import { useParams } from 'react-router-dom'

const ProductDetail = () => {
  const [productData, setProductData] = useState([])
  const { id } = useParams()

  const getProductData = async () => {
    try {
      const response = await getItemsByID(id);
      setProductData(response?.categoryItemData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getProductData();
  }, []);

  return (
    <>
      <ProductDetailStartSection />
      <AboutProduct productData={productData} />
      <ProductReview productData={productData}/>
      <SimilarProducts productData={productData} />
      <NeedOfCustomDesign />
      <FollowOnInstagram />
    </>
  )
}

export default ProductDetail
